import { render, staticRenderFns } from "./MeasurementDetailsModal.vue?vue&type=template&id=23f6bdf6&scoped=true"
import script from "./MeasurementDetailsModal.vue?vue&type=script&lang=js"
export * from "./MeasurementDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./MeasurementDetailsModal.vue?vue&type=style&index=0&id=23f6bdf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f6bdf6",
  null
  
)

export default component.exports